import Helper from '@ember/component/helper';
import { isEmpty } from '@ember/utils';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { service } from '@ember/service';

export default class LearnerField extends Helper {
  @service
  schoolSchema;

  compute(params) {
    let [field] = params;

    if (params.length < 1 || params.length > 2 || isEmpty(params[0])) {
      return null;
    }

    return this.schoolSchema.peekField(PersonType.LEARNER, field);
  }
}
